// Local-calendar date helpers + Monday-anchored week grouping.
//
// Extracted from SignalHistory.jsx when the Journal timeline needed the
// same grouping. Both screens render a reverse-chronological list of
// dated cards under "Week of …" dividers, and two copies of this logic
// would drift the moment one of them fixed a timezone bug the other
// didn't.
//
// The timezone care is the whole point: `new Date('2026-05-26')` parses
// as UTC midnight, which lands on the previous calendar day for anyone
// west of UTC. Every function here parses date components manually so
// the weekday a user sees matches the weekday they lived.

export function localDateKey(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function parseLocalDate(iso) {
  const [y, m, d] = String(iso).split("-").map(Number);
  return new Date(y, m - 1, d);
}

export function fullDayLabel(iso) {
  const d = parseLocalDate(iso);
  const weekday = d.toLocaleDateString("en-US", { weekday: "long" });
  const monthDay = d.toLocaleDateString("en-US", { month: "long", day: "numeric" });
  return `${weekday}, ${monthDay}`;
}

// ISO week anchor: rewind to Monday of the calendar week containing
// this date. Used as the section-header key — every card whose date
// falls in the same Mon-Sun range groups under one divider.
export function mondayOf(iso) {
  const d = parseLocalDate(iso);
  const dow = d.getDay(); // Sun=0
  const back = dow === 0 ? 6 : dow - 1;
  d.setDate(d.getDate() - back);
  return localDateKey(d);
}

export function weekHeader(mondayIso) {
  const d = parseLocalDate(mondayIso);
  return `Week of ${d.toLocaleDateString("en-US", { month: "long", day: "numeric" })}`;
}
